// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.option-accordion {
  position: relative;
  background-color: #f4f2ea;
}
.option-accordion .panel {
  width: auto;
  margin: 5px 25px 0 25px;
  border: none;
  background-color: transparent;
}
.option-accordion .panel .header {
  height: auto;
  vertical-align: middle;
  background-color: #f4f2ea;
}
.option-accordion .panel .header span {
  display: inline-block;
  height: 24px;
  width: 24px;
  vertical-align: top;
  margin-top: 15px;
}
.option-accordion .panel .header span.icon {
  background-image: url('unfilled-plus-grey.741f0fe719bb2d75.svg');
  background-repeat: no-repeat;
  background-position: 50%;
}
.option-accordion .panel .header span.icon.active {
  background-image: url('unfilled-plus.12cf3c2da4d95201.svg');
}
.option-accordion .panel .header span.icon.active.open {
  background-image: url('unfilled-circle-x.8122d2f1408175c5.svg');
}
.option-accordion .panel .header .oa-title {
  display: inline-block;
  margin-left: 25px;
}
.option-accordion .panel .header .oa-title p {
  display: inline-block;
  margin-top: 20px;
  vertical-align: middle;
  font-weight: 600;
}
.option-accordion .panel .header .oa-options {
  margin-left: 48px;
  padding-bottom: 15px;
  display: flex;
}
.option-accordion .panel .header .oa-options .option-item {
  flex: 50%;
}
.option-accordion .panel .header .oa-selected {
  padding: 20px 0 20px 50px;
}
.option-accordion .panel .header .oa-selected p {
  padding-bottom: 0;
}
.option-accordion .panel .body {
  border-top: 1px solid #d4cfbe;
  background-color: #f4f2ea;
  height: auto;
  padding: 20px 0;
}
.option-accordion .panel .body.hidden {
  display: none;
}
.option-accordion .panel .body .oa-body .col-sm-12 {
  margin-bottom: 15px;
}
.option-accordion .panel .body .oa-body .col-sm-12 .half {
  width: 50%;
}
.option-accordion .panel .body .oa-body .col-sm-12 .text-wrapper#fill textarea#topic {
  width: 100%;
  height: 80px !important;
  border: 1px solid orange;
}
.option-accordion .panel .body .oa-body .col-sm-12 textarea#fill {
  max-height: none !important;
}
.option-accordion .panel .body .oa-body .radio-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}
.option-accordion .panel .body .oa-body .radio-list li p.inline-block {
  margin-bottom: 5px;
  vertical-align: middle;
}
.option-accordion .panel .oa-buttons {
  text-align: right;
  padding-top: 20px;
}
.option-accordion .panel .oa-buttons button {
  text-align: center;
  margin-left: 10px;
}
.option-accordion .panel .buttons {
  text-align: right;
}
.option-accordion .panel .buttons button {
  text-align: center;
  margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/option-accordion/option-accordion.component.less"],"names":[],"mappings":"AAGE;EACE,kBAAA;EACA,yBAAA;AAFJ;AAAE;EAKI,WAAA;EACA,uBAAA;EACA,YAAA;EACA,6BAAA;AAFN;AANE;EAWM,YAAA;EACA,sBAAA;EACA,yBAAA;AAFR;AAXE;EAgBQ,qBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAFV;AAIU;EACE,gEAAA;EACA,4BAAA;EACA,wBAAA;AAFZ;AAIY;EACE,2DAAA;AAFd;AAIc;EACE,+DAAA;AAFhB;AA7BE;EAsCQ,qBAAA;EACA,iBAAA;AANV;AAjCE;EA0CU,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AANZ;AAvCE;EAkDQ,iBAAA;EACA,oBAAA;EACA,aAAA;AARV;AA5CE;EAsDU,SAAA;AAPZ;AA/CE;EA2DQ,yBAAA;AATV;AAlDE;EA8DU,iBAAA;AATZ;AArDE;EAoEM,6BAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AAZR;AAcQ;EACE,aAAA;AAZV;AA9DE;EA+EU,mBAAA;AAdZ;AAjEE;EAkFY,UAAA;AAdd;AApEE;EAuFc,WAAA;EACA,uBAAA;EACA,wBAAA;AAhBhB;AAzEE;EA8FY,2BAAA;AAlBd;AA5EE;EAmGU,gBAAA;EACA,eAAA;EACA,gBAAA;AApBZ;AAjFE;EAyGc,kBAAA;EACA,sBAAA;AArBhB;AArFE;EAkHM,iBAAA;EACA,iBAAA;AA1BR;AAzFE;EAsHU,kBAAA;EACA,iBAAA;AA1BZ;AA7FE;EA4HM,iBAAA;AA5BR;AAhGE;EA+HU,kBAAA;EACA,iBAAA;AA5BZ","sourcesContent":["@import (reference) \"../../styles/variables.less\";\n\n  //Option Accordion Styling\n  .option-accordion {\n    position: relative;\n    background-color: @primary-40;\n\n    .panel {\n      width: auto;\n      margin: 5px 25px 0 25px;\n      border: none;\n      background-color: transparent;\n\n      .header {\n        height: auto;\n        vertical-align: middle;\n        background-color: @primary-40;\n\n        span {\n          display: inline-block;\n          height: 24px;\n          width: 24px;\n          vertical-align: top;\n          margin-top: 15px;\n\n          &.icon {\n            background-image: url('../../styles/img/unfilled-plus-grey.svg');\n            background-repeat: no-repeat;\n            background-position: 50%;\n\n            &.active {\n              background-image: url('../../styles/img/unfilled-plus.svg');\n\n              &.open {\n                background-image: url('../../styles/img/unfilled-circle-x.svg');\n              }\n            }\n          }\n        }\n\n        .oa-title {\n          display: inline-block;\n          margin-left: 25px;\n\n          p {\n            display: inline-block;\n            margin-top: 20px;\n            vertical-align: middle;\n            font-weight: 600;\n          }\n        }\n\n        .oa-options {\n          margin-left: 48px;\n          padding-bottom: 15px;\n          display: flex;\n          .option-item {\n            flex: 50%;\n          }\n        }\n\n        .oa-selected {\n          padding: 20px 0 20px 50px;\n\n          p {\n            padding-bottom: 0;\n          }\n        }\n      }\n\n      .body {\n        border-top: 1px solid @primary-50;\n        background-color: @primary-40;\n        height: auto;\n        padding: 20px 0;\n\n        &.hidden {\n          display: none;\n        }\n\n        .oa-body {\n          .col-sm-12 {\n            margin-bottom: 15px;\n\n            .half {\n              width: 50%;\n            }\n\n            .text-wrapper#fill {\n              textarea#topic {\n                width: 100%;\n                height: 80px !important;\n                border: 1px solid orange;\n              }\n            }\n\n            textarea#fill {\n              max-height: none !important;\n            }\n          }\n\n          .radio-list {\n            list-style: none;\n            padding-left: 0;\n            margin-bottom: 0;\n\n            li {\n              p.inline-block {\n                margin-bottom: 5px;\n                vertical-align: middle;\n              }\n            }\n          }\n        }\n      }\n\n      .oa-buttons {\n        text-align: right;\n        padding-top: 20px;\n\n        button {\n            text-align: center;\n            margin-left: 10px;\n        }\n    }\n\n      .buttons {\n        text-align: right;\n\n        button {\n            text-align: center;\n            margin-left: 10px;\n        }\n      }\n    }\n\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
